import BulkUpdaterSummary from './BulkUpdaterSummary';

export default BulkUpdaterSummary;
